import React, { useState, useEffect } from "react";
import Select from "react-select"; // Cần cài đặt: npm install react-select
import axiosClient from "../../config/axiosClient";
import API_ENDPOINTS from "../../config/api";
import KPIModal from "./KPIModal"; 
import "./KPIList.css"; 

const PAGE_SIZE = 10;

const KPIList = () => {
  const [kpis, setKpis] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [filterUser, setFilterUser] = useState(""); 
  
  // 1. Chuyển filterDepts thành mảng để lưu nhiều lựa chọn
  const [filterDepts, setFilterDepts] = useState([]); 
  
  const [showModal, setShowModal] = useState(false);
  const [editingKPI, setEditingKPI] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const fetchData = async () => {
    try {
      const [resKPI, resDept, resUser] = await Promise.all([
        axiosClient.get(API_ENDPOINTS.kpis),
        axiosClient.get(API_ENDPOINTS.departments),
        axiosClient.get(API_ENDPOINTS.users)
      ]);
      
      const getData = (res) => Array.isArray(res.data) ? res.data : (res.data?.data || []);
      const kpiData = getData(resKPI);
      const deptData = getData(resDept);
      const userData = getData(resUser);

      const deptMap = {};
      deptData.forEach(d => { deptMap[d.id] = d.name; });
      const kpisWithDeptName = kpiData.map(k => ({ ...k, departmentName: deptMap[k.departmentId] || "N/A" }));

      setKpis(kpisWithDeptName);
      setDepartments(deptData);
      setUsers(userData);
    } catch (error) {
      console.error("❌ Fetching error:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  // --- GIỮ NGUYÊN CÁC LOGIC CŨ ---
  const handleImport = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const formData = new FormData();
    formData.append("File", file);
    try {
      const response = await axiosClient.post(API_ENDPOINTS.kpiImport, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      const { inserted, errors } = response.data;
      if (inserted > 0) alert(`Successfully imported ${inserted} records!`);
      if (errors?.length > 0) console.warn("❌ Lines with errors:", errors);
      fetchData();
      e.target.value = null;
    } catch (error) {
      alert("Import failed! Error: " + (error.response?.data?.error || error.message));
    }
  };

  const handleDeleteAll = async () => {
    if (!window.confirm("WARNING: Are you sure you want to delete ALL KPI data?")) return;
    try {
      await axiosClient.delete(`${API_ENDPOINTS.kpis}/delete-all`);
      alert("All KPI records have been cleared!");
      fetchData();
      setCurrentPage(1);
    } catch (error) { alert("Delete failed!"); }
  };

  const handleExport = async () => {
    try {
      const response = await axiosClient.get(API_ENDPOINTS.kpiExport, { responseType: "blob" });
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `KPI_Export_${new Date().getTime()}.xlsx`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) { alert("Export failed!"); }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this KPI?")) return;
    try {
      await axiosClient.delete(`${API_ENDPOINTS.kpis}/${id}`);
      fetchData();
    } catch (error) { console.error("Delete error:", error); }
  };

  const handleSave = async (data) => {
    try {
      if (editingKPI) await axiosClient.put(`${API_ENDPOINTS.kpis}/${editingKPI.id}`, data);
      else await axiosClient.post(API_ENDPOINTS.kpis, data);
      fetchData();
      setShowModal(false);
      setEditingKPI(null);
    } catch (error) {
      alert("Failed to save data. Please check F12 for details.");
    }
  };

  // 2. CẬP NHẬT LOGIC LỌC (Hỗ trợ nhiều bộ phận)
  const filteredData = kpis.filter(k => {
    const code = k.kpiCode || "";
    const desc = k.description || "";
    const userName = k.userName || "";
    
    const matchesSearch = code.toLowerCase().includes(search.toLowerCase()) || 
                          desc.toLowerCase().includes(search.toLowerCase()) ||
                          userName.toLowerCase().includes(search.toLowerCase());
    
    const matchesUser = filterUser === "" || String(k.userId) === filterUser;
    
    // Lấy danh sách ID đã chọn từ multi-select
    const selectedDeptIds = filterDepts.map(d => String(d.value));
    const matchesDept = selectedDeptIds.length === 0 || selectedDeptIds.includes(String(k.departmentId));
    
    return matchesSearch && matchesUser && matchesDept;
  });

  const totalPages = Math.ceil(filteredData.length / PAGE_SIZE);
  const currentData = filteredData.slice((currentPage - 1) * PAGE_SIZE, currentPage * PAGE_SIZE);

  // Format data cho react-select
  const deptOptions = departments.map(d => ({ value: d.id, label: d.name }));

  const thStyle = { backgroundColor: "#f8f9fc", color: "#28a745", fontWeight: "bold", fontSize: "0.8rem", textTransform: "uppercase" };

  return (
    <div className="container-fluid py-4">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white py-3 d-flex justify-content-between align-items-center flex-wrap gap-3">
          <h5 className="m-0 font-weight-bold text-success text-uppercase" style={{fontSize: "1rem"}}>KPI Management</h5>
          
          <div className="d-flex gap-2 align-items-center flex-wrap">
            
            {/* 3. THAY THẾ SELECT ĐƠN BẰNG MULTI-SELECT */}
            <div style={{ minWidth: "220px" }}>
              <Select
                isMulti
                options={deptOptions}
                placeholder="-- Departments --"
                value={filterDepts}
                onChange={(selected) => { setFilterDepts(selected || []); setCurrentPage(1); }}
                className="basic-multi-select"
                classNamePrefix="select"
                styles={{
                  control: (base) => ({ 
                    ...base, 
                    borderRadius: "20px", 
                    fontSize: "0.85rem", 
                    minHeight: "31px",
                    borderColor: "#dee2e6"
                  }),
                  valueContainer: (base) => ({ ...base, padding: "0 8px" }),
                  input: (base) => ({ ...base, margin: "0px" })
                }}
              />
            </div>

            <select 
              className="form-select form-select-sm" 
              style={{ width: "160px", borderRadius: "20px" }}
              value={filterUser}
              onChange={(e) => { setFilterUser(e.target.value); setCurrentPage(1); }}
            >
              <option value="">-- All Users --</option>
              {users.map(u => <option key={u.id} value={u.id}>{u.userName}</option>)}
            </select>

            <input
              type="text"
              className="form-control form-control-sm"
              style={{ width: "180px", borderRadius: "20px" }}
              placeholder="Search KPI/User..."
              value={search}
              onChange={(e) => { setSearch(e.target.value); setCurrentPage(1); }}
            />

            <div className="btn-group shadow-sm">
              <button className="btn btn-sm btn-light border" onClick={handleExport} title="Export to Excel">
                <i className="fas fa-file-export text-success"></i>
              </button>
              <label className="btn btn-sm btn-light border mb-0" style={{ cursor: "pointer" }} title="Import from Excel">
                <i className="fas fa-file-import text-warning"></i> 
                <input type="file" accept=".xlsx" hidden onChange={handleImport} />
              </label>
            </div>

            <button className="btn btn-sm btn-success px-3 rounded-pill shadow-sm fw-bold" onClick={() => { setEditingKPI(null); setShowModal(true); }}>
              <i className="fas fa-plus me-1"></i> Add KPI
            </button>

            
          </div>
        </div>

        <div className="card-body p-0">
          <div className="table-responsive">
            <table className="table table-hover align-middle mb-0" style={{fontSize: "0.85rem"}}>
              <thead>
                <tr>
                  <th className="text-center" style={thStyle}>No.</th>
                  <th style={thStyle}>KPI Code</th>
                  <th style={thStyle}>Description</th>
                  <th style={thStyle}>Target</th>
                  <th style={thStyle}>Department</th> 
                  <th style={thStyle}>Assignee</th>
                  <th className="text-center" style={thStyle}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {currentData.length > 0 ? currentData.map((k, idx) => (
                  <tr key={k.id}>
                    <td className="text-center text-muted">{(currentPage - 1) * PAGE_SIZE + idx + 1}</td>
                    <td><span className="badge bg-light text-success border">{k.kpiCode}</span></td>
                    <td><div className="text-muted text-truncate" style={{maxWidth: "200px"}} title={k.description}>{k.description}</div></td>
                    <td><strong>{k.targetValue}</strong> <small>{k.unit}</small></td>
                    <td><span className="badge rounded-pill bg-info text-dark fw-normal">{k.departmentName || "N/A"}</span></td>
                    <td><span className="fw-bold">{k.userName || "N/A"}</span></td>
                    <td className="text-center">
                      <div className="d-flex justify-content-center gap-2">
                        <button className="btn btn-sm btn-outline-success border-0 rounded-circle" onClick={() => { setEditingKPI(k); setShowModal(true); }}>
                          <i className="fas fa-pencil-alt"></i>
                        </button>
                        <button className="btn btn-sm btn-outline-danger border-0 rounded-circle" onClick={() => handleDelete(k.id)}>
                          <i className="fas fa-trash-alt"></i>
                        </button>
                      </div>
                    </td>
                  </tr>
                )) : (
                  <tr><td colSpan="7" className="text-center py-5 text-muted">No KPI records found.</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
      
      {totalPages > 1 && (
        <div className="card-footer bg-white border-0 py-3 d-flex justify-content-center">
            <nav>
              <ul className="pagination pagination-sm mb-0">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(p => p - 1)}>Prev</button>
                </li>
                <li className="page-item disabled"><span className="page-link text-dark">Page {currentPage} / {totalPages}</span></li>
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                  <button className="page-link" onClick={() => setCurrentPage(p => p + 1)}>Next</button>
                </li>
              </ul>
            </nav>
        </div>
      )}

      <KPIModal 
        show={showModal} 
        initialData={editingKPI} 
        departments={departments} 
        users={users} 
        onClose={() => { setShowModal(false); setEditingKPI(null); }} 
        onSave={handleSave} 
      />
    </div>
  );
};

export default KPIList;